import React from 'react';
import { About, Contact, Download, Footer, Header, Services } from './containers';
import { Navbar } from './components';
import './App.css'

const App = () => {
  return (
    <div className="App">
        <div className='gradient__header'>
          <Navbar />
          <Header />
        </div>
        <About />
        <Services />
        <Download />
        <Contact />
        <div className='gradient__footer'>
          <Footer />
        </div>
    </div>
  )
}

export default App